import { render, staticRenderFns } from "./GuestFooter.vue?vue&type=template&id=161d8f53&scoped=true"
import script from "./GuestFooter.vue?vue&type=script&lang=js"
export * from "./GuestFooter.vue?vue&type=script&lang=js"
import style0 from "./GuestFooter.vue?vue&type=style&index=0&id=161d8f53&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161d8f53",
  null
  
)

export default component.exports